<template>
  <div class="content">
    <div class="holder container">
      <div class="content-confirm-order col-md-10 col-lg-7 col-12">
        <div class="d-flex justify-content-center w-100 mt-4 mb-4">
          <div
            :class="[
              'content-confirm-order-body',
              'mt-0',
              'mb-0',
              { 'p-0': isMobile },
            ]"
          >
            <div class="content-confirm-order-body-item m-0 mr-2">
              <div class="d-table w-100 h-100">
                <div class="d-table-cell align-middle text-center">
                  <p class="label-size">{{ $t('front_end.a065.front') }}</p>
                  <img
                    :src="frontImage"
                    class="img-print img-border"
                    v-if="frontImage"
                  />
                  <div class="img-print img-border" v-else></div>
                </div>
              </div>
            </div>
            <div class="content-confirm-order-body-item m-0 ml-2">
              <div class="d-table w-100 h-100">
                <div class="d-table-cell align-middle text-center">
                  <p class="label-size">{{ $t('front_end.a065.behind') }}</p>
                  <img
                    :src="behindImage"
                    class="img-border img-print"
                    v-if="behindImage"
                  />
                  <div class="img-print img-border" v-else></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p class="content-confirm-order-order-ttl label-size">
          {{ $t('front_end.a065.content_order') }}
        </p>
        <div class="content-confirm-order-order">
          <div class="form-title-content justify-content-start">
            <span class="font-weight-bold"
              >{{ $t('front_end.a065.invoice_detail.id_order') }}:
              {{ order.orderNo }}</span
            >
          </div>
          <table
            class="table-content-invoice"
            v-if="calculationInformation && calculationInformation.order"
          >
            <tr v-if="calculationInformation.order">
              <td colspan="3" class="content-confirm-order-order-table-number">
                {{ $t('front_end.a065.invoice_detail.date_order') }}
              </td>
              <td class="text-right">
                {{
                  jpDate.toJpDate(
                    new Date(calculationInformation.order.orderDate)
                  )
                }}
              </td>
            </tr>
            <tr v-if="calculationInformation.order">
              <td colspan="3" class="content-confirm-order-order-table-number">
                {{ $t('front_end.a065.invoice_detail.type_order') }}
              </td>
              <td class="text-right">
                {{ calculationInformation.order.typeNo }}
              </td>
            </tr>
            <tr>
              <td colspan="4">
                {{ $t('front_end.a065.invoice_detail.detail_invoice') }}
              </td>
            </tr>
            <!-- fee basic -->

            <tr>
              <td rowspan="2" class="col-start-invoice">
                <!-- no.9.7.1.1 -->
                {{
                  calculationInformation.order.isReorder === false
                    ? $t('front_end.a065.invoice_detail.fee_basic_print')
                    : $t('front_end.a065.invoice_detail.fee_basic_image')
                }}
              </td>
              <td colspan="2">
                <!-- No.09-07-01-02?? -->
                <div class="d-flex justify-content-between">
                  <p class="m-0">
                    {{ calculationInformation.order.type }}
                    <span class="text-danger"
                      >（{{
                        calculationInformation.order.photoOrPrint === 'print'
                          ? $t('front_end.a065.invoice_detail.print_type.print')
                          : $t(
                              'front_end.a065.invoice_detail.print_type.image'
                            )
                      }}）</span
                    >
                  </p>
                </div>
              </td>
              <td class="col-end-invoice text-right">
                {{ calculationInformation.basicPrice.fee | number_format
                }}{{ $t('front_end.a065.yen') }}
              </td>
            </tr>

            <tr>
              <td colspan="2">
                <div class="d-flex justify-content-between">
                  <p class="m-0">
                    {{ $t('front_end.a065.invoice_detail.consumption_tax') }}
                  </p>
                  <p class="m-0">
                    {{ calculationInformation.information.tax }}%
                  </p>
                </div>
              </td>
              <td class="col-end-invoice text-right">
                {{ calculationInformation.basicPrice.dispTax | number_format
                }}{{ $t('front_end.a065.yen') }}
              </td>
            </tr>

            <!-- fee print -->
            <tr v-if="this.reOrder">
              <td rowspan="2" class="col-start-invoice">
                <!-- no 9.7.2.1 -->
                {{ $t('front_end.a065.invoice_detail.fee_print') }}
              </td>
              <td colspan="2">
                <div class="d-flex justify-content-between">
                  <p class="m-0">
                    {{ $t('front_end.a065.invoice_detail.number_of_print') }}
                  </p>
                  <p class="m-0">
                    {{ calculationInformation.printPrice.price | number_format
                    }}{{ $t('front_end.a065.yen') }}&emsp;{{
                      calculationInformation.printPrice.count | number_format
                    }}
                    {{ $t('front_end.a065.invoice_detail.sheet') }}
                  </p>
                </div>
              </td>
              <td class="col-end-invoice text-right">
                {{ calculationInformation.printPrice.fee | number_format
                }}{{ $t('front_end.a065.yen') }}
              </td>
            </tr>

            <!-- thue cua vung chi phi in  -->
            <tr v-if="this.reOrder">
              <td colspan="2">
                <div class="d-flex justify-content-between">
                  <p class="m-0">
                    {{ $t('front_end.a065.invoice_detail.consumption_tax') }}
                  </p>
                  <p class="m-0">
                    {{ calculationInformation.information.tax }}%
                  </p>
                </div>
              </td>
              <td class="col-end-invoice text-right">
                {{ calculationInformation.printPrice.tax | number_format
                }}{{ $t('front_end.a065.yen') }}
              </td>
            </tr>

            <!-- fee option -->
            <template
              v-if="
                calculationInformation.option &&
                  (calculationInformation.option.addressname ||
                    calculationInformation.option.stamp)
              "
            >
              <tr v-if="calculationInformation.option.stamp">
                <td
                  :rowspan="
                    calculationInformation.option.stamp &&
                    calculationInformation.option.addressname
                      ? 4
                      : 3
                  "
                >
                  <!-- No 9.7.3.1 -->
                  {{ $t('front_end.a065.invoice_detail.money_option') }}
                </td>
                <td v :colspan="2">
                  <div class="d-flex justify-content-between">
                    <p class="m-0">
                      <!-- No 9.7.3.2.1 -->
                      {{ $t('front_end.a065.invoice_detail.stamp') }}
                    </p>
                    <p class="m-0">
                      {{
                        calculationInformation.option.stamp.price
                          | number_format
                      }}{{ $t('front_end.a065.yen') }}&emsp;&nbsp;{{
                        calculationInformation.option.stamp.count
                          | number_format
                      }}
                      {{ $t('front_end.a065.invoice_detail.unit_stamp') }}
                    </p>
                  </div>
                </td>
                <td class="col-end-invoice text-right">
                  {{ calculationInformation.option.stamp.fee | number_format
                  }}{{ $t('front_end.a065.yen') }}
                </td>
              </tr>
              <tr v-if="calculationInformation.option.addressname">
                <td v-if="!calculationInformation.option.stamp" :rowspan="3">
                  {{ $t('front_end.a065.invoice_detail.money_option') }}
                </td>
                <td colspan="2">
                  <div class="d-flex justify-content-between">
                    <p class="m-0">
                      {{ $t('front_end.a065.invoice_detail.address_print') }}
                    </p>

                    <p class="m-0">
                      {{
                        calculationInformation.option.addressname.price
                          | number_format
                      }}{{ $t('front_end.a065.yen') }}&emsp;&nbsp;{{
                        calculationInformation.option.addressname.count
                          | number_format
                      }}
                      {{ $t('front_end.a065.invoice_detail.item') }}
                    </p>
                  </div>
                </td>

                <td class="col-end-invoice text-right">
                  {{
                    calculationInformation.option.addressname.fee
                      | number_format
                  }}{{ $t('front_end.a065.yen') }}
                </td>
              </tr>

              <!-- tong option -->
              <tr class="color-row-total-option color-row-total-option">
                <td colspan="2" class="text-right">
                  {{ $t('front_end.a065.invoice_detail.fee_total') }}
                </td>
                <td class="col-end-invoice text-right">
                  {{ calculationInformation.option.totalFee | number_format
                  }}{{ $t('front_end.a065.yen') }}
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <div class="d-flex justify-content-between">
                    <p class="m-0">
                      {{ $t('front_end.a065.invoice_detail.consumption_tax') }}
                    </p>
                    <p class="m-0">
                      {{ calculationInformation.information.tax }}%
                    </p>
                  </div>
                </td>
                <td class="col-end-invoice text-right">
                  {{ calculationInformation.option.tax | number_format
                  }}{{ $t('front_end.a065.yen') }}
                </td>
              </tr>
            </template>

            <!-- vung total  phi co ban + phi in + phi option -->
            <tr class="color-row-total-option">
              <td colspan="3" class="text-right">
                {{ $t('front_end.a065.invoice_detail.fee_total') }}
              </td>
              <td class="col-end-invoice text-right">
                {{
                  calculationInformation.totalFeeBasicPrintOption
                    | number_format
                }}{{ $t('front_end.a065.yen') }}
              </td>
            </tr>

            <!-- discount -->
            <tr v-if="calculationInformation.discount.discount">
              <td>{{ $t('front_end.a065.invoice_detail.discount') }}</td>
              <td colspan="2">
                <div class="d-flex justify-content-between">
                  <p class="m-0">
                    {{ calculationInformation.discount.discount.discountName }}
                  </p>
                  <p
                    class="m-0"
                    v-if="
                      calculationInformation.discount.discount
                        .discountMethod !== `金額`
                    "
                  >
                    {{ $t('front_end.a065.invoice_detail.fee_basic_print') }}
                  </p>
                  <p
                    class="m-0"
                    v-if="
                      calculationInformation.discount.discount.discountMethod ==
                        `割引率`
                    "
                  >
                    {{
                      calculationInformation.discount.discount.discountContent +
                        `%OFF`
                    }}
                  </p>
                </div>
              </td>
              <td class="col-end-invoice text-right">
                -{{
                  calculationInformation.discount.discount.discount
                    | number_format
                }}{{ $t('front_end.a065.yen') }}
              </td>
            </tr>

            <!-- coupon -->
            <tr v-if="calculationInformation.discount.coupon">
              <td>{{ $t('front_end.a065.invoice_detail.coupon') }}</td>
              <td colspan="2">
                <div class="d-flex justify-content-between">
                  <p
                    class="m-0"
                    v-if="
                      calculationInformation.discount.coupon.discountMethod !==
                        `金額`
                    "
                  >
                    {{ $t('front_end.a065.invoice_detail.fee_basic_print') }}
                  </p>
                  <p
                    class="m-0"
                    v-if="
                      calculationInformation.discount.coupon.discountMethod ==
                        `割引率`
                    "
                  >
                    {{
                      calculationInformation.discount.coupon.discountContent +
                        `%OFF`
                    }}
                  </p>
                </div>
              </td>
              <td class="col-end-invoice text-right">
                -{{
                  calculationInformation.discount.coupon.discount
                    | number_format
                }}{{ $t('front_end.a065.yen') }}
              </td>
            </tr>

            <!-- tong so tien giam gia -->
            <tr
              class="color-row-after-discount"
              v-if="
                calculationInformation.discount &&
                  (calculationInformation.discount.discount ||
                    calculationInformation.discount.coupon)
              "
            >
              <td colspan="3" class="text-right">
                {{ $t('front_end.a065.invoice_detail.fee_after_discount') }}
              </td>
              <td class="col-end-invoice text-right">
                {{
                  Number(
                    calculationInformation.totalFeeBasicPrintOption -
                      calculationInformation.discount.sumDiscount
                  ) | number_format
                }}{{ $t('front_end.a065.yen') }}
              </td>
            </tr>

            <!-- phi postcard -->
            <tr v-if="calculationInformation.postcard">
              <td>{{ $t('front_end.a065.invoice_detail.fee_postcard') }}</td>

              <td colspan="2">
                <div class="d-flex justify-content-between">
                  <p class="m-0">{{ calculationInformation.postcard.name }}</p>
                  <p class="m-0">
                    {{ calculationInformation.postcard.price
                    }}{{ $t('front_end.a065.yen') }}
                  </p>

                  <p class="m-0">
                    {{ calculationInformation.postcard.count
                    }}{{ $t('front_end.a065.invoice_detail.sheet') }}
                  </p>
                </div>
              </td>

              <!-- <td
                class="text-right"
              >{{`${order.pricePostcard}${money_suffixes}`}}&emsp;{{`${order.quantityPostcard}${$t('front_end.a065.invoice_detail.sheet')}`}}</td>-->
              <td class="col-end-invoice text-right">
                {{ calculationInformation.postcard.fee | number_format
                }}{{ $t('front_end.a065.yen') }}
              </td>
            </tr>

            <!-- tong so tien -->
            <!-- クレジット -->
            <tr class="color-row-final" v-if="isCredit">
              <td colspan="3" class="text-right">
                <!-- NO.09.07.06 -->
                {{ $t('front_end.a065.invoice_detail.all_item') }}
              </td>
              <td class="col-end-invoice text-right">
                {{ calculationInformation.finalFee | number_format
                }}{{ $t('front_end.a065.yen') }}
              </td>
            </tr>
            <!-- total tax -->
            <tr class="color-row-final" v-if="isCredit">
              <td colspan="3" class="text-right">
                <!-- NO.09.07.06 -->
                {{ $t('front_end.a065.invoice_detail.consumption_tax') }}
              </td>
              <td class="col-end-invoice text-right">
                {{ calculationInformation.totalTax | number_format
                }}{{ $t('front_end.a065.yen') }}
              </td>
            </tr>

            <!-- 代引き -->
            <tr class="color-row-total-option" v-if="!isCredit">
              <td colspan="3" class="text-right">
                <!-- NO.09.07.06 -->
                {{ $t('front_end.a065.invoice_detail.all_item') }}
              </td>
              <td class="col-end-invoice text-right">
                {{ calculationInformation.preFinalFee | number_format
                }}{{ $t('front_end.a065.yen') }}
              </td>
            </tr>

            <!-- chi phi cod -->
            <tr v-if="!isCredit">
              <td colspan="3">{{ $t('front_end.a115.label.fee_cod') }}</td>
              <td class="col-end-invoice text-right">
                {{ calculationInformation.cashOnDelivery.fee | number_format
                }}{{ $t('front_end.a065.yen') }}
              </td>
            </tr>

            <!-- tong so tien cuoi cung -->
            <tr class="color-row-final" v-if="!isCredit">
              <td colspan="3" class="text-right">
                <!-- NO.09.07.06 -->
                {{ $t('front_end.a115.label.payment_amount') }}
              </td>
              <td class="col-end-invoice text-right">
                {{ calculationInformation.finalFee | number_format
                }}{{ $t('front_end.a065.yen') }}
              </td>
            </tr>
            <!-- total tax -->
            <tr class="color-row-final" v-if="!isCredit">
              <td colspan="3" class="text-right">
                <!-- NO.09.07.06 -->
                {{ $t('front_end.a065.invoice_detail.consumption_tax') }}
              </td>
              <td class="col-end-invoice text-right">
                {{ calculationInformation.totalTax | number_format
                }}{{ $t('front_end.a065.yen') }}
              </td>
            </tr>

          </table>
        </div>

        <!-- check bien lai -->
        <div class="check-print-invoice mt-3 mb-3">
          <div>
            <label class="custom-control checkcontainer custom-checkbox">
              <input
                v-model="printInvoice"
                type="checkbox"
                class="d-none-lala"
                hidden
              />
              <span class="checkmark"></span>
            </label>
          </div>
          <p class="ml-2">
            {{ $t('front_end.a065.message_check_print_invoice') }}
          </p>
        </div>

        <!-- vung nguoi order -->
        <div class="content-confirm-order-order">
          <div class="form-title-content">
            <span class="font-weight-bold">{{
              $t('front_end.a065.orderer')
            }}</span>
          </div>
          <table class="content-confirm-order-order-table">
            <tr>
              <td class="content-confirm-order-order-table-number">1</td>
              <td>{{ $t('front_end.a065.name') }}</td>
              <td>{{ userInfo.last_name }} {{ userInfo.first_name }}</td>
            </tr>
            <tr>
              <td class="content-confirm-order-order-table-number">2</td>
              <td>{{ $t('front_end.a065.mail_address') }}</td>
              <td>{{ userInfo.email || 'ー' }}</td>
            </tr>
            <tr>
              <td class="content-confirm-order-order-table-number">3</td>
              <td>{{ $t('front_end.a065.phone_number') }}</td>
              <td>
                {{
                  `${userInfo.phone_number_first}-${userInfo.phone_number_second}-${userInfo.phone_number_third}`
                }}
              </td>
            </tr>
            <tr>
              <td class="content-confirm-order-order-table-number">4</td>
              <td>{{ $t('front_end.a065.shipping_address') }}</td>
              <td>
                {{
                  userInfo.zipCodeFirst
                    ? `〒${userInfo.zipCodeFirst} - ${userInfo.zipCodeLast}`
                    : 'ー'
                }}
                <p class="m-0">
                  {{ userInfo.prefecture }} {{ userInfo.city }}
                  {{ userInfo.street }} {{ userInfo.building || '' }}
                </p>
              </td>
            </tr>
            <tr>
              <td class="content-confirm-order-order-table-number">5</td>
              <td>{{ $t('front_end.a065.company_name') }}</td>
              <td v-if="userInfo.company">{{ userInfo.company }}</td>
              <td v-else>ー</td>
            </tr>
            <tr>
              <td class="content-confirm-order-order-table-number">6</td>
              <td>{{ $t('front_end.a065.department_name') }}</td>
              <td v-if="userInfo.department">{{ userInfo.department }}</td>
              <td v-else>ー</td>
            </tr>
            <tr>
              <td class="content-confirm-order-order-table-number">7</td>
              <td>{{ $t('front_end.a065.comment') }}</td>
              <td style="white-space: pre-wrap">
                {{ userInfo.comment || 'ー' }}
              </td>
            </tr>
          </table>
        </div>

        <!-- thanh toan -->
        <div class="content-confirm-order-order-footer mt-3">
          <div class="content-confirm-order-order">
            <div>
              <div class="form-title-content">
                <span class="font-weight-bold">{{
                  $t('front_end.a065.pay_method')
                }}</span>
              </div>
            </div>
            <!-- 決済方法選択 -->
            <table class="content-confirm-order-order-table mb-5">
              <tr>
                <td colspan="3" class="content-confirm-order-order-table-payment">
                  {{$t('front_end.a130.payment_method_title')}}
                </td>
                <td>
                  {{ this.paymentMethodSelect }}
                </td>
              </tr>
              <tr>
                <td colspan="3" class="content-confirm-order-order-table-payment">
                  {{$t('front_end.a125.delivery_method_title')}}
                </td>
                <td>
                  {{$t('front_end.a125.delivery_method')}}
                </td>
              </tr>
            </table>

            <div class="content-confirm-order-order mb-5">
              <div class="line-end margin-item"></div>
            </div>

            <!-- 注意事項 -->
            <div class="content-body p-0 mb-5">
              <div class="scroll-box">
                <div class="scroll-box-inner">
                  <div class="policy">
                    <p v-html="rawPrecautions"></p>
                  </div>
                </div>
              </div>
            </div>

            <div class="content-confirm-order-order mb-5">
              <div class="line-end margin-item"></div>
              <p class="text-center mt-4 mb-2 label-size">
                {{ $t('front_end.a130.message_confirm') }}
              </p>
              <div v-if="isCredit">
                <p class="text-center m-0 mb-2 label-size">
                  {{ $t('front_end.a065.message_payment') }}
                </p>
                <p class="text-center m-0 message-color-red label-size">
                  {{ $t('front_end.a065.message_complete') }}
                </p>
              </div>
            </div>
            <div class="content-confirm-order-footer">
              <button
                @click="showDialogConfirmOrder()"
                class="content-confirm-order-footer-btn m-5"
                :disabled="!rawPrecautions"
              >
                {{ $t('front_end.a130.confirm_paymet') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- modal thanh toan -->
    <fe-alert ref="modalConfirm" :datas="dataAlert">
      <template v-slot:default>
        <div class="form-group text-center cursor-default">
          {{ 
            isCredit
            ? $t('front_end.a065.message_confirm_payment')
            : $t('front_end.a115.modal.confirm.text')
          }}
        </div>
      </template>
      <template v-slot:action>
        <button
          type="button"
          @click="onModalConfirmYes"
          class="btn-dialog col-6 border-top border-right"
        >
          {{ $t('front_end.a065.yes') }}
        </button>
        <button
          type="button"
          @click="onModalConfirmCancel"
          class="btn-dialog col-6 border-top border-left"
        >
          {{ $t('front_end.a065.cancel') }}
        </button>
      </template>
    </fe-alert>

    <!-- form thanh toan -->
    <form
      ref="paymentKuroneko"
      :action="envConfig.PAYMENT.KURONEKO.GATEPAY"
      method="post"
      accept-charset="Shift_JIS"
    >
      <input type="hidden" name="TRS_MAP" value="V_W02" />
      <input
        type="hidden"
        name="trader_code"
        :value="envConfig.PAYMENT.KURONEKO.trader_code"
      />
      <input
        type="hidden"
        name="order_no"
        :value="
          calculationInformation.order && calculationInformation.order.orderNo
            ? calculationInformation.order.orderNo
            : ''
        "
      />
      <input
        type="hidden"
        v-if="calculationInformation && calculationInformation.order"
        name="goods_name"
        :value="calculationInformation.order.typeNo"
      />
      <input
        type="hidden"
        name="settle_price"
        :value="calculationInformation.finalFee"
      />
      <input
        type="hidden"
        name="buyer_name_kanji"
        :value="userInfo.last_name + whilespacejp + userInfo.first_name"
      />
      <input
        type="hidden"
        name="buyer_name_kana"
        :value="
          userInfo.last_name_kana + whilespacejp + userInfo.first_name_kana
        "
      />
      <input
        type="hidden"
        name="buyer_tel"
        :value="
          userInfo.phone_number_first +
            '-' +
            userInfo.phone_number_second +
            '-' +
            userInfo.phone_number_third
        "
      />
      <input type="hidden" name="buyer_email" :value="userInfo.email" />
      <input
        type="hidden"
        name="return_url"
        :value="envConfig.PAYMENT.KURONEKO.return_url"
      />
      <input
        type="hidden"
        name="success_url"
        :value="callBackUrls.success_url"
      />
      <input
        type="hidden"
        name="failure_url"
        :value="callBackUrls.failure_url"
      />
      <input type="hidden" name="cancel_url" :value="callBackUrls.cancel_url" />
    </form>
  </div>
</template>
<script>
import jpDate from '@/helpers/jpDate'
import api from '@/services/api'
import apiEndpoints from '@/services/apiEndpoints'
import { mapGetters, mapState } from 'vuex'
import FeAlert from '@/components/fe/common/FeAlert'
import envConfig from '@/configs/env/config'
var md5 = require('md5')

export default {
  // created() {
  //   this.order.orderNo = this.$route.params.orderNo;
  // },
  name: 'A130',
  data() {
    return {
      loader: null,
      whilespacejp: '　',
      dataAlert: {
        isShow: false,
        dismissText: '',
        confirmText: '',
        content: '',
        success: '',
        img: '',
      },
      isMobile: false,
      money_suffixes: '円',
      frontImage: '',
      behindImage: '',
      payMethod: '',
      userInfo: {
        first_name: '',
        last_name: '',
        first_name_kana: '',
        last_name_kana: '',
        phone_number_first: '',
        phone_number_second: '',
        phone_number_third: '',
        email: '',
        prefecture: '',
        city: '',
        street: '',
        zip_code: '',
        comment: '',
      },
      isModeShop: false,
      printInvoice: false,
      postCardImage: false,
      typePostcard: this.$t('front_end.a065.invoice_detail.postcard_normal'),
      textButtonConfirm: this.$t('front_end.a065.confirm'),
      isReOrder: false,
      isEditUserInfo: false,
      messageEditUser: this.$t('front_end.a065.confirm_edit_user_info'),
      btnYes: this.$t('front_end.a065.yes'),
      btnCancel: this.$t('front_end.a065.cancel'),
      isConfirmPayment: false,
      messageConfirmPayment: this.$t('front_end.a065.message_confirm_payment'),
      isConfirmPaymentShop: false,
      messageConfirmPaymentShop: this.$t(
        'front_end.a065.message_confirm_payment_shop'
      ),
      postcardID: null,
      isBringPostcard: false,
      postcardBring: 0,
      order: {
        date: '',
        orderNo: '',
        typeTemplate: null,
        category: '',
        numberReceiver: 0,
        numberPrint: 0,
        quantityPostcard: 0,
        feePrintBasic: 0,
        tax: 10,
        feeTaxBasic: 0,
        quantityScope: 0,
        feePrint: 0,
        feeTaxPrint: 0,
        pricePrint: 0,
        rowPrintOption: 4,
        stampQuantity: 0,
        feeStamp: 0,
        priceStamp: 0,
        pricePrintAddress: 0,
        feePrintAddress: 0,
        feeTotalOption: 0,
        feeTaxOption: 0,
        feeTotalNotDiscount: 0,
        discount: 0,
        feeDiscount: 0,
        feeAfterDiscount: 0,
        messageDiscount: '',
        namePostCard: '',
        pricePostcard: 0,
        feePostcard: 0,
        feeFinal: 0,
        templateName: '',
        typeDiscount: '',
        printType: 0,
      },
      dataOrderInfo: {},
      // fake config
      configFake: {
        print_type: {
          print: 0,
          image: 1,
        },
      },
      callBackUrls: {
        cancel_url: '',
        success_url: '',
        failure_url: '',
      },
      calculationInformation: {},
      calculationInformation12: {
        information: { tax: 10 },
        order: {
          orderNo: '',
          orderDate: '',
          typeNo: '',
          type: '',
          photoOrPrint: '',
          isReorder: false,
        },
        basicPrice: { fee: 0, tax: 0 },
        printPrice: { count: 0, price: 0, fee: 0, tax: 0 },
        discount: {
          discount: {
            discountMethod: '',
            discountContent: 0,
            discountName: '',
            discount: 0,
          },
          coupon: {
            couponCode: '',
            discountMethod: '',
            discountContent: '',
            discount: '',
          },
        },
        postcard: {
          name: '0',
          count: 0,
          price: 0,
          fee: 0,
        },
      },
      dataEditAlert: {},
      paymentMethodSelect: null,
      isCredit: true,
      rawPrecautions: "",
    }
  },
  components: {
    FeAlert,
  },
  computed: {
    ...mapGetters(['shopMode', 'userData']),
    ...mapState({
      reOrder: (state) => state.userData.order.reOrder,
    }),
  },
  watch: {
    printInvoice(newValue) {
      this.$store.commit('userData/SET_SELECTED', {
        print_invoice: newValue,
      })
    },
  },
  async created() {
    this.jpDate = jpDate
    this.envConfig = envConfig
    this.isModeShop = !!this.shopMode?.shopName
    await this.onInit()

    await this.getPriceInfomation()
    this.createCallBackUrl()
  },
  mounted() {
    this.printInvoice =
      this.$store.state.userData.selected.printInvoice ?? this.printInvoice
  },
  methods: {
    textReplacement(base, holder, replace) {
      return base.replace(holder, replace)
    },
    createCallBackUrl() {
      let md5OrderNo = md5(this.order.orderNo)
      let cancel_url = this.textReplacement(
        envConfig.PAYMENT.KURONEKO.cancel_url,
        '{orderNo}',
        md5OrderNo
      )

      let success_url = this.textReplacement(
        envConfig.PAYMENT.KURONEKO.success_url,
        '{orderNo}',
        md5OrderNo
      )
      let failure_url = this.textReplacement(
        envConfig.PAYMENT.KURONEKO.failure_url,
        '{orderNo}',
        md5OrderNo
      )

      this.callBackUrls = {
        cancel_url,
        success_url,
        failure_url,
      }
    },
    async onInit() {
      if (!this.$store.state.userData?.selected?.payment_method) {
        // 選択している決済情報がない場合はエラーにする
        this.$store.dispatch('errorStore/redirectErrorPage', {
          status: '',
          message: '',
        })
      }
      this.paymentMethodSelect = this.$store.state.userData.selected.payment_method
      this.isCredit = (this.paymentMethodSelect == this.$t('front_end.a125.select_payment_method_list.credit'))
      if (this.$store.state.userData?.selected?.print_invoice) {
        this.printInvoice = this.$store.state.userData.selected.print_invoice
      }
      this.behindImage = await this.getImageBackFromOrderNoHashed(
        this.userData?.order?.orderNo
      )
      this.frontImage = this.userData?.order?.thumbnailFrontURL
      this.order.orderNo = this.userData?.order?.orderNo

      let {
        ordererFirstName: first_name,
        ordererLastName: last_name,
        kanaFirstName: first_name_kana,
        kanaLastName: last_name_kana,
        mailAddress: email,
        phone1: phone_number_first,
        phone2: phone_number_second,
        phone3: phone_number_third,
        prefectures: prefecture,
        city,
        streetAddress1: street,
        companyName: company,
        departmentName: department,
        comment,
        postalCode,
        streetAddress2: building,
      } = this.userData.order?.ordererInformation || {}

      let zipCodeFirst = null
      let zipCodeLast = null
      if (postalCode) {
        zipCodeFirst = postalCode.substr(0, 3)
        zipCodeLast = postalCode.substr(3)
      }
      this.userInfo = {
        first_name,
        last_name,
        first_name_kana,
        last_name_kana,
        phone_number_first,
        phone_number_second,
        phone_number_third,
        email,
        prefecture,
        city,
        street,
        company,
        department,
        comment,
        building,
        zipCodeFirst,
        zipCodeLast,
      }
    },
    async getImageBackFromOrderNoHashed(orderNo) {
      //CR :1pfwb8sZ
      // this.ordererInformation.orderNo = "020081301000125";
      try {
        let respEdu = await api.post(apiEndpoints.editDataUploadUrl, {
          orderNo: orderNo,
          filename: 'preview-image-' + orderNo,
          accessType: 'preview',
        })

        // console.log("respEdu", respEdu);
        if (respEdu && respEdu.data?.url) {
          return respEdu.data.url
        }
      } catch (error) {
        return ''
      }
    },
    async getPriceInfomation() {
      let { orderNo } = this.order
      const paymentMethod = this.isCredit ? 'WEB' : 'DELIVERY'
      let { data } = await api.post(apiEndpoints.getpriceconfirminformation, {
        orderNo,
        paymentMethod,
      })
      if (data && data.calculationInformation) {
        this.calculationInformation = this.preCalculate(data.calculationInformation)
        this.rawPrecautions = data.precautions
      } else {
        // 決済情報が取得できていない場合はエラーにする
        this.$store.dispatch('errorStore/redirectErrorPage', {
          status: '',
          message: '',
        })
      }
    },

    preCalculate(calcInfo) {
      let {
        information = {},
        order = {},
        basicPrice = {},
        printPrice = {},
        option = {},
        discount = {},
        postcard = {},
        cashOnDelivery = {},
      } = {
        ...calcInfo,
      }

      let totalTax = 0
      option.totalFee = 0
      if (option?.addressname?.fee) {
        option.totalFee += Number(option.addressname.fee)
      }

      if (option.stamp?.fee) {
        option.totalFee += Number(option.stamp.fee)
      }

      discount.sumDiscount = 0

      if (discount.discount?.discount) {
        discount.sumDiscount += Number(discount.discount.discount)
      }
      if (discount.coupon?.discount) {
        discount.sumDiscount += Number(discount.coupon.discount)
      }

      let finalFee = 0

      let totalFeeBasicPrintOption = 0
      //totalFeeBasicPrintOption
      if (basicPrice) {
        if (basicPrice.fee) {
          finalFee += Number(basicPrice.fee)
        }

        if (basicPrice.tax) {
          totalTax += Number(basicPrice.tax)
        }
      }

      if (printPrice) {
        if (printPrice.fee) {
          finalFee += Number(printPrice.fee)
        }
        if (printPrice.tax) {
          totalTax += Number(printPrice.tax)
        }
      }

      //stamp + address

      if (option.stamp?.fee) {
        finalFee += Number(option.stamp.fee)

        if (option.stamp?.tax) {
          totalTax += Number(option.stamp.tax)
        }
      }

      if (option.addressname?.fee) {
        finalFee += Number(option.addressname.fee)
        if (option.addressname.tax) {
          totalTax += Number(option.addressname.tax)
        }
      }

      totalFeeBasicPrintOption = finalFee

      if (cashOnDelivery?.fee) {
        finalFee += Number(cashOnDelivery.fee)
        if (cashOnDelivery.tax) {
          totalTax += Number(cashOnDelivery.tax)
        }
      }

      if (discount.discount?.discount) {
        finalFee -= Number(discount.discount.discount)
      }
      if (discount.coupon?.discount) {
        finalFee -= Number(discount.coupon.discount)
      }

      if (postcard?.fee) {
        finalFee += Number(postcard.fee)
      }

      // total without cod fee
      let preFinalFee = finalFee
      if (cashOnDelivery?.fee) {
        preFinalFee -= Number(cashOnDelivery.fee)
      }

      return {
        information,
        finalFee,
        order,
        basicPrice,
        printPrice,
        option,
        discount,
        postcard,
        totalFeeBasicPrintOption,
        cashOnDelivery,
        totalTax,
        preFinalFee,
      }
    },
    showDialogConfirmOrder() {
      this.$refs.modalConfirm.show()
    },
    onModalConfirmCancel() {
      this.$refs.modalConfirm.hide()
    },
    showLoading() {
      this.loader = this.$loading.show({
        // Optional parameters
        container: null,
        color: '#DD0017',
        loader: 'dots',
        width: 64,
        height: 64,
        backgroundColor: '#ffffff',
        opacity: 0.5,
      })
    },
    hideLoading() {
      this.loader.hide()
      this.loader = null
    },
    async onModalConfirmYes() {
      if (!this.isModeShop) {
        if (!this.isCredit) {
          this.$refs.modalConfirm.hide()
          let orderNo = this.calculationInformation.order?.orderNo
          let settlePrice = Number(this.calculationInformation.finalFee)
          let settleDate = this.$moment().format('YYYY/MM/DD')
          let totalConsumptionTax = this.calculationInformation.totalTax
          let cashOnDeliveryFee = Number(this.calculationInformation.cashOnDelivery.fee)
          let body = {
            orderNo,
            printOrder: this.printInvoice ? `PRINT` : `NOPRINT`,
            settlePrice,
            settleDate,
            totalConsumptionTax,
            cashOnDeliveryFee,
          }
          this.showLoading()
          let respConfirm = await api.post(
            apiEndpoints.cashOnDeliverySettlement,
            body
          )
          //200 ok
          if (respConfirm) {
            this.hideLoading()
            this.$router.push({
              name: 'a120',
              params: { orderNo: md5(this.order.orderNo) },
            })
          }
        } else {
          //kuroneko
          this.showLoading()
          await this.callUpdatePrintOrder()

          // eslint-disable-next-line
          modChar(this.$refs.paymentKuroneko)
        }
      }
    },
    async callUpdatePrintOrder() {
      let orderNo = this.calculationInformation.order?.orderNo
      // PRINT | NOPRINT
      return await api.post(apiEndpoints.updatePrintOrder, {
        orderNo,
        printOrder: this.printInvoice ? `PRINT` : `NOPRINT`,
      })
    },
  },
}
</script>
<style
  lang="css"
  scoped
  src="../../assets/css/confirmOrder/confirmOrder.css"
></style>
<style scoped>
/* Create a custom checkbox */
.custom-checkbox {
  margin-bottom: 0;
}

.checkmark {
  position: absolute;
  top: 50%;
  left: 50%;
  height: 20px;
  width: 20px;
  background-color: #fff;
  transform: translate(-50%, -50%);
  border: 0.1px solid #000;
  border-radius: 2px;
}

/* On mouse-over, add a grey background color */
.custom-checkbox:hover input ~ .checkmark {
  background-color: #fff;
}

/* When the checkbox is checked, add a blue background */
.custom-checkbox input:checked ~ .checkmark {
  background-color: red;
  border: 0.1px solid red;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.custom-checkbox input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.custom-checkbox .checkmark:after {
  left: 50%;
  top: 50%;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: translate(-50%, -50%) rotate(45deg);
  -webkit-transform: translate(-50%, -50%) rotate(45deg);
  -ms-transform: translate(-50%, -50%) rotate(45deg);
}
.text-box {
  margin-top: 22px;
}
.icon-select {
  color: #dd0017;
}
.m-5 {
  margin: 5px !important;
}
@media screen and (max-width: 768px) {
  .content-confirm-order-footer-btn {
    font-size: 14px;
  }
}
.content-confirm-order-order-table-payment {
  width: 10%;
}
.content-body {
  height: 30vh;
  margin: 0 auto 4vh;
  border: 2px solid rgba(66, 66, 66, 0.66)
}
.scroll-box {
  overflow-y: scroll;
  max-height: 100%;
}
.scroll-box-inner {
  padding: 10px;
}
.policy {
  font-size: 13px;
}
.policy-text-title {
  font-weight: normal;
}
</style>
